var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.152 10.748a.45.45 0 01-.704 0L4.78 7.398a.45.45 0 01.352-.73h5.333a.45.45 0 01.353.73l-2.667 3.35z",
    fill: "#2C2842"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMTUxOTcgMTAuNzQ4MkM3Ljk3MTgyIDEwLjk3NDUgNy42Mjc5OSAxMC45NzQ1IDcuNDQ3ODMgMTAuNzQ4Mkw0Ljc4MTIzIDcuMzk4MzNDNC41NDY1NCA3LjEwMzUxIDQuNzU2NDcgNi42NjgwNiA1LjEzMzMgNi42NjgwNkwxMC40NjY1IDYuNjY4MDZDMTAuODQzMyA2LjY2ODA2IDExLjA1MzMgNy4xMDM1MSAxMC44MTg2IDcuMzk4MzNMOC4xNTE5NyAxMC43NDgyWiIgZmlsbD0iIzJDMjg0MiIvPgo8L3N2Zz4K";
export { SvgTriangleBlack as ReactComponent };